// Actividad: el registro de lo que se ha hecho en el panel (solo el propietario).
import { useEffect, useState } from 'react';
import { api, type AuditEntry } from '../../api.ts';
import { t } from '../../i18n/index.ts';
import { errorText, useApp } from '../../store.ts';
import { ago, fullDate } from '../../format.ts';

export function Activity() {
  const notify = useApp((s) => s.notify);
  const [rows, setRows] = useState<AuditEntry[] | null>(null);
  useEffect(() => {
    api
      .audit()
      .then((r) => setRows(r.entries))
      .catch((e) => notify(errorText(e), true));
  }, [notify]);
  return (
    <section className="section">
      <h2>{t('ws.activity')}</h2>
      <div className="list">
        {(rows ?? []).map((r) => (
          <div key={r.id} className="list-row">
            <span className="mono" style={{ width: 170, flexShrink: 0 }}>
              {r.action}
            </span>
            <span className="grow ellipsis muted" title={r.detail ? JSON.stringify(r.detail) : ''}>
              {r.user ?? '—'}
              {r.detail ? ` · ${JSON.stringify(r.detail)}` : ''}
            </span>
            <span className="hint" title={fullDate(r.at)}>
              {ago(r.at)}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}
